import Swiper from "swiper";
import "swiper/css";

export default function initSocialCarousel() {
  const socialSections = document.querySelectorAll(".social-section");

  if (!socialSections.length) return;

  socialSections.forEach((socialSection) => {
    const swiperContainer = socialSection.querySelector(".swiper");

    if (!swiperContainer) return;

    new Swiper(swiperContainer, {
      slidesPerView: 1.2,
      centeredSlides: false,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      grabCursor: true,
      loop: false,
      breakpoints: {
        744: {
          slidesPerView: 2.5,
        },
        744: {
          spaceBetween: 24,
          slidesOffsetBefore: 24,
          slidesOffsetAfter: 24,
        },
        1280: {
          slidesPerView: 2.8,
          spaceBetween: 32,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        },
      },
    });
  });
}
